import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Typography from '../UI/Typography'
import Button from '../UI/Button'
import { device } from '../../utils/helpers'

// Features
const Wrapper = styled.div`
  margin-top: 80px;

  @media ${device.tablet} {
    margin-top: 120px;
  }
`

const Section = styled.section`
  background: ${props => props.grey ? props.theme.color.bgLight : '#fff'};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
`

const InfoSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: left;
  background: #f3f3f3;
  padding: 4rem 0;

  @media ${device.laptop} {
    padding: 7rem 0;
  }
`

const Title = styled.div`
  padding: 3.6rem 1.5rem;
  text-align: center;
`

const BigTitle = styled.div`
  padding: 4.5rem 4.5rem 0 4.5rem;
  text-align: center;

  @media ${device.laptop} {
    width: 500px;
  }

  @media ${device.laptopL} {
    width: 700px;
  }
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding-bottom: 30px;
  width: 90%;

  @media ${device.laptop} {
    width: 70%;
    padding-bottom: 40px;
  }

  @media ${device.desktop} {
    width: 65%;
    padding-bottom: 40px;
  }
`

const ButtonWrapper = styled.div`
  padding: 4.5rem 0;

  @media ${device.tablet} {
    padding: 2.5rem 1.5rem;
  }

  @media ${device.laptop} {
    padding-bottom: 4rem;
  }
`

const UList = styled.ul`
  font-size: 16px;
  padding: 0 1.2rem;

  @media ${device.laptop} {
    font-size: 18px;
  }

  @media ${device.laptopL} {
    font-size: 20px;
  }
`

const ListItem = styled.li`
  @media ${device.laptopM} {
    margin-left: 1em
  }
`

class Condizioni extends Component {
  render () {
    return (
      <Wrapper>
        <Helmet>
          <title>Noleggiocampi.it Termini e Condizioni d'uso</title>
          <meta name='Description' content='Pagina contenente i Termini e le Condizioni d"uso della piattaforma Noleggiocampi.it e di tutti i servizi connessi' />
          <meta name='Keywords' content='campi smontabili,noleggio attrezzature sportive,noleggio impianti sportivi mobili' />
          <meta name='robots' content='noindex, nofollow' />
        </Helmet>
        <Title>
          <Typography variant='h1' type='title'>CONDIZIONI</Typography>
        </Title>
        <InfoSection>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>CONDIZIONI D’USO</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Il sito internet <a href='www.noleggiocampi.it' target='_blank'>www.noleggiocampi.it</a> (di seguito <i>“piattaforma”</i>) è amministrato dalla società AD4 srls, con sede legale in Via B. Marcello, 1 – 20124 – MILANO (MI), P.IVA 09076750968 (di seguito ”AD4”).
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Le presenti condizioni sono valide esclusivamente tra AD4 e qualsiasi persona (di seguito ”UTENTE”) che utilizza i servizi offerti tramite la piattaforma.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Le condizioni ed i termini di seguito specificati si applicano al contenuto dell'intera piattaforma e, unitamente a qualunque pagina o documento ai quali tali condizioni e termini possono fare riferimento, costituiscono i termini e le condizioni in base ai quali AD4 consente l'utilizzazione della piattaforma.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              L'accesso ai contenuti della piattaforma è subordinato alla lettura attenta e all'accettazione dei presenti Termini e condizioni d'uso (di seguito “Condizioni”). L'utilizzo della piattaforma implica l'accettazione integrale delle <i>Condizioni</i>.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>1. PREMESSA</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Tutte le sezioni della piattaforma sono accessibili senza necessità di registrazione. Viene tuttavia richiesto l’inserimento di alcuni dati personali - quali Nome, Cognome, Nome Azienda, Numero di Telefono e Indirizzo e-mail – al fine di poter inviare via e-mail all’UTENTE il resoconto della propria configurazione di noleggio. Per il trattamento di tali dati AD4 si attiene a quanto esposto nella <a href='#'>Privacy Policy</a>.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              AD4 si riserva di modificare in qualunque momento le Condizioni stabilite di seguito, semplicemente aggiornando questa pagina di avvisi legali. Pertanto si invitano gli interessati a verificare periodicamente la versione più aggiornata di queste Condizioni. Si sottolinea altresì che alcuni dei termini o delle condizioni di seguito specificate potrebbero essere derogate e superate da previsioni specifiche riportate in altre sezioni della <i>piattaforma</i>.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              La data di pubblicazione delle Condizioni sulla piattaforma equivale alla data di entrata in vigore delle stesse.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>2. OGGETTO DEL CONTRATTO</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Con le presenti Condizioni, AD4 mette a disposizione dell’UTENTE un servizio di configurazione e preventivazione del costo per il noleggio, allestimento e trasporto delle strutture esposte sulla piattaforma attraverso un software di elaborazione dati (di seguito <i>“configuratore”</i>).
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Il risultato della configurazione non rappresenta in alcun modo una proposta contrattuale vincolante per AD4 e per l’UTENTE. L’”Ordine” emesso dal configuratore ha la sola funzione di fornire un contatto tra richiesta (UTENTE) ed offerta (AD4). Ciascuna delle parti potrà non dare seguito all’”Ordine” senza alcuna conseguenza giuridica.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Successivamente alla ricezione dell’Ordine AD4 si impegna alla trasmissione all’UTENTE di una proposta commerciale (“Preventivo”).
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>3. CONFIGURATORE</Typography>
            <Typography padding='0 0 10px 0' variant='h5' type='title'>3.1 Funzionamento</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              L’utente, attraverso la piattaforma, ha la possibilità di configurare il proprio noleggio scegliendo tra diverse strutture disponibili (es. campo da calcetto, campo da basket, campo da beach-volley).
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Seguendo vari step vi è la possibilità di scegliere tra differenti configurazioni ed allestimenti (es. transenne di contenimento, rete di protezione, impianto audio, impianto luci, etc.).
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              In tempo reale vengono mostrati i prezzi preventivati in base alla configurazione selezionata.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Al termine della configurazione vengono calcolate le spese di trasporto e montaggio in base alla località selezionata.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Conclusa la procedura di configurazione il configuratore invia all’UTENTE tramite e-mail un resoconto della configurazione del proprio noleggio (“Ordine”).
            </Typography>
            <Typography padding='0 0 10px 0' variant='h5' type='title'>3.2 Prezzi esposti</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Lo scopo della piattaforma è di fornire all’UTENTE una stima di massima rispetto ai costi da sostenere per effettuare il noleggio delle strutture.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              I prezzi esposti tramite il <i>preventivatore</i> e inviati tramite e-mail sono espressi in euro (€) includenti IVA (22%) e non rappresentano in alcun modo un’offerta contrattuale vincolante né per AD4 né per l’UTENTE.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>4. CONDIZIONI DI LICENZA</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Salvo quanto diversamente disposto in queste stesse Condizioni o in altre sezioni della piattaforma, tutti i diritti d'autore e qualunque altro diritto di proprietà intellettuale o industriale o qualunque altro diritto di qualunque natura in uno qualunque dei contenuti o degli aspetti della piattaforma, appartiene ad AD4 o sono concessi in licenza ad AD4 da parte dei rispettivi titolari. Tali opere sono protette dalle leggi locali e dai trattati internazionali in materia di proprietà industriale e diritto d'autore, ed i diritti sulle stesse sono espressamente riservati. È vietato qualunque utilizzo dei contenuti della piattaforma che non sia espressamente consentito da queste Condizioni. In caso di violazione di una qualunque delle Condizioni, AD4 si riserva il diritto di vietare l'accesso alla piattaforma e di richiedere l'immediata restituzione o distruzione di qualunque materiale stampato o scaricato dalla piattaforma.
            </Typography>
            <Typography padding='0 0 10px 0' minSize='16px' maxSize='24px'>
              È consentito all'UTENTE di stampare o scaricare alcuni estratti della piattaforma limitatamente ad un uso strettamente personale e a condizione che:
            </Typography>
            <UList>
              <ListItem>nessun documento o elemento grafico della piattaforma sia modificato in alcun modo;</ListItem>
              <ListItem>nessun elemento grafico della piattaforma venga utilizzato separatamente dal testo di riferimento;</ListItem>
              <ListItem>la dichiarazione di diritto d'autore (copyright) e le dichiarazioni di marchio registrato o di brevetto (complessivamente i “Credits”), insieme alla menzione della presente licenza vengano allegate ad ogni copia estratta della piattaforma.</ListItem>
            </UList>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Qualunque copia, cartacea o digitale, dei materiali scaricati o stampati della piattaforma non può essere modificata in alcun modo, e non è consentito l'utilizzo disgiunto delle immagini, fotografie, video, audio, grafica o altro rispetto ai Credits ad essi relativi.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Deve sempre essere attestata la posizione di AD4, o della/e persona/e da questi indicata/e, quale autore del materiale pubblicato sulla piattaforma.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Conclusa la procedura di configurazione il configuratore invia all’UTENTE tramite e-mail un resoconto della configurazione del proprio noleggio (“Ordine”).
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Salvo quanto stabilito sopra, nessuna parte della piattaforma potrà essere riprodotta o archiviata in un qualunque altro sito web o inclusa in un qualunque sistema di archiviazione e ricerca di informazioni o di erogazione di servizi, senza il preventivo consenso di AD4.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Qualunque altro diritto o autorizzazione non espressamente menzionati in queste condizioni sono espressamente riservati.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>5. ACCESSO ALLA PIATTAFORMA</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              AD4 farà quanto ragionevolmente possibile, secondo uno standard di ragionevolezza commerciale, per fare in modo che la piattaforma sia sempre accessibile. AD4 non sarà tuttavia responsabile se, per una qualunque ragione, la piattaforma dovesse essere indisponibile anche solo per limitati periodi di tempo.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              L'accesso alla piattaforma può essere temporaneamente sospeso, anche senza previo avviso, nel caso di errori di sistema, necessità di assistenza o manutenzione, o per qualunque altra ragione al di là del ragionevole controllo di AD4.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              L'UTENTE è responsabile in proprio per l'attivazione ed il mantenimento di tutti gli accordi e servizi che consentono l'accesso alla piattaforma.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>6. COMPORTAMENTO E MATERIALE DI PROPRIETÀ DELL'UTENTE</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Ad eccezione dei dati di carattere personale che saranno trattati in conformità a quanto appena specificato, qualunque materiale, contenuto, ecc. trasmesso o inserito sulla piattaforma sarà considerato non-confidenziale e non-proprietario. Pertanto AD4 non assume alcuna obbligazione con riferimento a tali informazioni e materiali e si intenderà autorizzato ad acquisire copia, trasmettere, rivelare, utilizzare tali materiali, sia per finalità di carattere commerciale, sia per finalità diverse.
            </Typography>
            <Typography padding='0 0 10px 0' minSize='16px' maxSize='24px'>
              L'UTENTE si impegna a non inserire o trasmettere in o dalla piattaforma qualunque materiale:
            </Typography>
            <UList>
              <ListItem>che sia intimidatorio, diffamatorio, osceno, indecente, sedizioso, offensivo, pornografico, abusivo, tale da incitare all'odio razziale, discriminatorio o discriminante, minaccioso, scandaloso, incitante, blasfemo, lesivo di obblighi di segretezza, lesivo della privacy o che possa in qualunque modo produrre fastidio o danno; o</ListItem>
              <ListItem>per il quale non siano state ottenute le necessarie licenze o approvazioni; o</ListItem>
              <ListItem>che rappresenta o incoraggia comportamenti che potrebbero essere considerati forme di reato, che possano ingenerare la responsabilità di chiunque, che siano in qualunque modo contrari alla legge, all'ordine pubblico o al buon costume o che ledano diritti di terzi in qualunque parte nel mondo; o</ListItem>
              <ListItem>che cagionino danno (inclusi, senza limitazione alcuna, computer virus, logic bombs, Trojan horses, worms, componenti difettosi, dati corrotti o altri software dal contenuto lesivo o in grado di danneggiare).</ListItem>
            </UList>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              L'UTENTE non può abusare del Sito (incluso, a titolo esemplificativo, mediante lo svolgimento di attività di hackeraggio).
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              AD4 coopererà attivamente con le autorità pubbliche incaricate di svolgere indagini e adempirà a qualunque ordine di giudice che richieda o che ordini ad AD4 di rivelare l'identità o di individuare i soggetti che trasmettono o inseriscono materiale non conforme alla legge e/o a quanto sopra stabilito.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>7. LINK A/DA ALTRI SITI</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Link a siti web di terze parti sulla piattaforma sono proposti solo per agevolare la fruizione dei contenuti. Utilizzandoli, si abbandona la piattaforma stessa. AD4 non ha svolto alcuna attività di verifica sui siti che vengono linkati dalla piattaforma e non controlla né è responsabile di come vengono gestiti detti siti, del loro contenuto e della loro disponibilità d'uso. AD4 perciò non garantisce o dichiara alcunché riguardo ad essi, ovvero al materiale che possa esservi rinvenuto, o di un qualunque risultato che possa ottenersi dal loro utilizzo. Allorché l'UTENTE decida di accedervi seguendo i link proposti dalla piattaforma, lo fa sotto la propria esclusiva responsabilità e a proprio rischio.
            </Typography>
            <Typography padding='0 0 10px 0' minSize='16px' maxSize='24px'>
              Se l'UTENTE desidera creare un proprio link alla piattaforma, può farlo esclusivamente a condizione che venga creato un effettivo link alla homepage della piattaforma, e che non sia replicato il contenuto della piattaforma, e a condizione che:
            </Typography>
            <UList>
              <ListItem>non siano rimosse, deformate o in qualunque altro modo alterate le dimensioni o le caratteristiche del marchio Noleggiocampi.it e del suo logo</ListItem>
              <ListItem>non sia creata alcuna cornice e/o non sia inserito un qualunque altro browser o ambientazione attorno alla piattaforma;</ListItem>
              <ListItem>tale link non implichi, anche in via indiretta, che AD4 stia promuovendo i prodotti o servizi di terze parti;</ListItem>
              <ListItem>con ciò non si tenti di rappresentare, neppure in via surrettizia, una qualche forma di relazione tra AD4 e l'UTENTE e neppure si tenti di veicolare informazioni false, tendenziose o distorte sul conto di AD4;</ListItem>
              <ListItem>tale link non sia attuato da un sito non amministrato dall'UTENTE;</ListItem>
              <ListItem>il sito web dell'UTENTE non presenti contenuti disgustosi, offensivi o polemici, lesivi di un qualunque diritto di proprietà intellettuale o di qualunque altro diritto di terze parti o che in qualunque altro modo violi norme di legge, di regolamento, l'ordine pubblico o il buon costume.</ListItem>
            </UList>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              AD4 si riserva in ogni momento di revocare il diritto dell'UTENTE di creare un link alla piattaforma ovvero di assumere un qualunque altro provvedimento che sia giudicato necessario od opportuno nel caso anche solo uno dei termini specificati in questa sezione venga violato.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              L'UTENTE dovrà mantenere indenne AD4 per ogni perdita o danno patito da AD4 per la violazione di una qualunque delle condizioni stabilite dalla presente sezione.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>8. AVVERTIMENTI IMPORTANTI</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              AD4 farà in modo che le informazioni pubblicate sulla piattaforma siano sempre corrette e aggiornate, tuttavia non viene con ciò rilasciata in alcun modo una qualunque garanzia circa l'attendibilità, l'accuratezza e la completezza delle informazioni presenti sulla piattaforma. AD4 potrà in qualunque momento modificare la piattaforma ed i suoi contenuti, ovvero modificare la descrizione dei prodotti e/o dei servizi ed eventualmente i loro prezzi, e ciò potrà fare anche senza preavviso alcuno. Resta inteso che AD4 non assume alcun impegno od obbligo di aggiornamento del materiale pubblicato sulla piattaforma.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Tutto ciò che viene pubblicato sulla piattaforma viene prodotto senza alcuna garanzia, condizione o altro. Allo stesso modo, salvo i soli limiti inderogabili di legge, AD4 consente all'UTENTE la frequentazione della piattaforma sul presupposto espresso che nessuna dichiarazione, garanzia, condizione o altro limite (incluso, senza limitazione alcuna, le garanzie implicite di buona qualità, adeguatezza per l'uso proposto ed il rispetto della diligenza del buon padre di famiglia o quella qualificata del professionista che, salvo che per ciò che viene escluso dalla presente condizione, potrebbero avere effetto con riguardo ai contenuti di questa piattaforma) abbiano effetto.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>9. RESPONSABILITÀ</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              È espressamente esclusa la responsabilità di AD4, o di qualunque altra parte che abbia agito per suo conto (indipendentemente dal fatto che sia stata implicata nella creazione, produzione, mantenimento o realizzazione della piattaforma) di ogni suo amministratore, direttore, dipendente, socio o agente, per qualunque ammontare e per qualunque tipologia di danno che possa derivare all'UTENTE o ad una qualunque terza parte (incluso, a titolo meramente esemplificativo e non esaustivo, qualunque danno diretto, indiretto, danno emergente, perdita di profitto, danno all'avviamento commerciale, perdita di dati, danno contrattuale o extracontrattuale, rivalutazione, interessi o altro, derivante da o in qualunque modo connesso all'interruzione di attività, incluso il fatto dovuto a mera omissione o negligenza, dipendente da responsabilità contrattuale o da responsabilità extracontrattuale) in qualunque modo dipendente dall'esercizio della piattaforma o in qualunque modo connessa all'uso, impossibilità d'uso o ai risultati di uso della piattaforma, ovvero dipendenti da qualunque altro sito web che sia linkato alla piattaforma o dal materiale presente su tali siti web, incluso, senza limite alcuno, la perdita o il danno dovuti alla diffusione di virus che possano infettare l'equipaggiamento elettronico dell'UTENTE (pc, tablet, smartphone o altro), i software, i dati o altre proprietà utilizzate per l'accesso, l'uso o il browsing della piattaforma da parte dell'UTENTE ovvero utilizzati per scaricare materiali dalla piattaforma o da altri siti linkati alla piattaforma.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              AD4 non assume alcuna responsabilità per disservizi imputabili a causa di forza maggiore o caso fortuito, anche ove dipendenti da malfunzionamenti e disservizi della rete internet, nel caso in cui non riesca a dare esecuzione all’ordine nei tempi previsti dal contratto.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              La presente limitazione di responsabilità non intende superare i limiti inderogabili di legge ovvero per i casi di dolo o colpa grave.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>10. CONDIZIONI PER L'UTILIZZO DELLA PIATTAFORMA</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              L'UTENTE si assume ogni onere e responsabilità per l'eventuale adeguamento della propria strumentazione hardware, software o altro o della riparazione, manutenzione o correzione degli stessi che siano necessari per poter accedere ai contenuti ovvero utilizzare i servizi erogati da questa piattaforma.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>11. INTEGRALITÀ</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Le presenti Condizioni sono costituite dalla totalità delle clausole che le compongono. Se una o più disposizioni delle presenti Condizioni è considerata non valida o dichiarata tale ai sensi della legge, della regolamentazione o in seguito a una decisione da parte di un tribunale avente giurisdizione, le altre disposizioni continueranno ad avere pieno vigore ed efficacia.
            </Typography>
          </Info>
          <Info>
            <Typography padding='0 0 20px 0' variant='h2' type='title'>12. LEGGE APPLICABILE E FORO COMPETENTE</Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Le presenti Condizioni Generali di Vendita sono sottoposte alla legge italiana.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              Ogni controversia che non trova soluzione amichevole sarà sottoposta alla competenza esclusiva del Tribunale di Milano.
            </Typography>
            <Typography padding='0 0 30px 0' minSize='16px' maxSize='24px'>
              In ogni caso, è possibile ricorrere facoltativamente alle procedure di mediazione di cui al D.lgs 28/2010, per la risoluzione di eventuali controversie insorte nell’interpretazione e nell’esecuzione delle presenti condizioni di vendita.
            </Typography>
          </Info>
          <Info>
            <Typography padding='20px 0 0 0' minSize='16px' maxSize='24px'>
              Milano, 21 novembre 2018
            </Typography>
          </Info>
        </InfoSection>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>HAI QUALCHE DOMANDA?</Typography>
          </BigTitle>
          <ButtonWrapper>
            <Button secondary to='/contattaci'>CONTATTACI</Button>
          </ButtonWrapper>
        </Section>
      </Wrapper>
    )
  }
}

export default Condizioni



// WEBPACK FOOTER //
// ./src/components/Pages/Condizioni.js